<template>
  <section class="mt-4 px-14 sm-max:px-5 pb-6 sm-max:mt-0">
    <div class="bg-greenBg flex lg:ml-36 md-max:flex-col border-2 border-[#358419] border-green md-max:p-5">
      <div class="float-left">
        <nuxt-img
            class="relative lg:right-40 lg:top-9 md-max:mb-2 m-auto md-max:pr-8 md:min-w-[311px]"
            width="326"
            height="368"
            loading="lazy"
            format="webp"
            :alt="imageAlt"
            :src="imageSrc"
        ></nuxt-img>
      </div>
      <div class="float-right space-y-5 sm-max:pt-0 font-21 italic sm-max:text-base lg:-ml-32 md-max:text-center lg:pr-28 lg:pl-4 pt-8">
        <div class="lg:text-21 md:text-lg text-15" v-html="text1"></div>
        <div class="lg:text-21 md:text-lg text-15 leading-6" v-html="text2"></div>
        <div class="lg:text-21 md:text-lg text-15 md-max:leading-6 leading-8" v-html="text3">
        </div>
        <div class="lg:text-21 md:text-lg text-15 md-max:leading-6 leading-8">
       {{text4}}
        </div>
        <div class="lg:text-21 md:text-lg text-15 leading-6 md-max:leading-6" v-html="text5"></div>
      </div>
    </div>

  </section>
</template>

<script setup>

const props = defineProps({
  text1: {
    type: String,
    default: 'Oh. My. God.',
  },
  text2: {
    type: String,
    default: 'This was it.',
  },
  text3: {
    type: String,
    default: 'I don’t even remember the name of the coffee shop. But I remember the taste. \'Like heaven in a cup.',
  },
  text4: {
    type: String,
    default: 'It was to that coffee that I’ve compared everything else.',
  },
  text5: {
    type: String,
    default: 'And nothing measured up, until now.',
  },

  imageSrc: {
    type: String,
    default: '/assets/images/freebag-sect2-img2.png',
  },
  imageAlt: {
    type: String,
    default: 'coffee',
  }
})

defineBuilderComponent({
    friendlyName: "Comment",
    canHaveChildren: true,
    inputs: [
        {
            name: "text1",
            type: "richText",
            defaultValue: "Oh. My. God."
        },
        {
            name: "text2",
            type: "richText",
            defaultValue: "This was it."
        },
        {
            name: "text3",
            type: "richText",
            defaultValue: "I don’t even remember the name of the coffee shop. But I remember the taste. Like heaven in a cup."
        },
        {
            name: "text4",
            type: "richText",
            defaultValue: "It was to that coffee that I’ve compared everything else."
        },
        {
            name: "text5",
            type: "richText",
            defaultValue: "And nothing measured up, until now."
        },
        {
            name: "text6",
            type: "richText",
            defaultValue: "What I’ve found is that regular mass-produced, blended coffee is loaded with chemicals and additives that destroy the flavor."
        },
        {
            name: "text7",
            type: "richText",
            defaultValue: "The best tasting coffee, it turns out, is also the healthiest coffee."
        },
        {
            name: "text8",
            type: "richText",
            defaultValue: "The coffee I’ve found is delicious and is the cleanest, purest, healthiest coffee I’ve ever seen."
        },
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/freebag-sect2-img2.png"
        },
        {
            name: "imageAlt",
            type: "text",
            defaultValue: "coffee"
        },
        {
            name: "buttonText",
            type: "text",
            defaultValue: "Save 50% Now"
        }
    ]
});
</script>